// extracted by mini-css-extract-plugin
export default {"socket":"src-containers-Socket--socket","socketActive":"src-containers-Socket--socketActive","button":"src-containers-Socket--button","event":"src-containers-Socket--event"};